import React from "react";

const EventCheckIn = () => {
  return (
    <div className="container-fluid">
      <div className="row mt-5">
        <div className="col-md-12">
          <h3>Event Check-In</h3>
          <p className="text-muted">
            Check-in functionality is coming soon. Please check back later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventCheckIn;
